import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment';
import { categoryDefaultDetails } from './fields/category/category.component';
import { FieldDetails } from './fields/fields.component';
@Injectable({
  providedIn: 'root'
})
export class CaseService {

  constructor(private http: HttpClient) { }

  getAllTypes(){
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getGroupAndUser(subCategoryId: number){
    return this.http.get<any>(`${environment.appUrl}Category/GetSubCategoryWiseUser/${subCategoryId}`);
  }

  saveGroupAndUser(data){
    return this.http.post<any>(`${environment.appUrl}Category/AddSubCategoryWiseUser`, data);
  }

  getCaseCategories() {
    return this.http.get<any>(`${environment.appUrl}Category/GetAll`);
  }

  addCaseSubCategory(data) {
    return this.http.post<any>(`${environment.appUrl}Category/Add`, data);
  }

  updateCaseSubCategory(data) {
    return this.http.put<any>(`${environment.appUrl}Category`, data);
  }

  updateIsDefaultField(data : FieldDetails){
    return this.http.put<any>(`${environment.configUrl}Configuration/ChangeDefaultField`, data)
        .toPromise()
        .then((res) => res);
  }

  updateCategoryIsDefaultField(data : categoryDefaultDetails){
    return this.http.put<any>(`${environment.appUrl}Category/ChangeDefaultCategory`, data)
        .toPromise()
        .then((res) => res);
  }

  getUserGroups(organizationId) {
    return this.http.get<any>(`${environment.appOrgUrl}UserGroup/GetMyUserGroups?OrganizationId=${organizationId}`)
  }

  getAllResolvedReason(){
    return this.http.get<any>(`${environment.appUrl}ClosedReason/GetAllResolvedReason`)
        .toPromise()
        .then((res) => res);
  }

  getAllUnresolvedReason(){
    return this.http.get<any>(`${environment.appUrl}ClosedReason/GetAllUnresolvedReason`)
        .toPromise()
        .then((res) => res);
  }

  addUpdateResolvedReason(data){
    return this.http.post<any>(`${environment.appUrl}ClosedReason/AddOrUpdateResolvedReason`, data)
        .toPromise()
        .then((res) => res);
  }

  addUpdateUnresolvedReason(data){
    return this.http.post<any>(`${environment.appUrl}ClosedReason/AddOrUpdateUnresolvedReason`, data)
        .toPromise()
        .then((res) => res);
  }

  changeIsDefaultResolvedReason(data){
    return this.http.put<any>(`${environment.appUrl}ClosedReason/ChangeDefaultResolvedReason`, data)
        .toPromise()
        .then((res) => res);
  }

  changeIsDefaultUnresolvedReason(data){
    return this.http.put<any>(`${environment.appUrl}ClosedReason/ChangeDefaultUnresolvedReason`, data)
        .toPromise()
        .then((res) => res);
  }

  deleteResolveReason(id){
    return this.http.delete<any>(`${environment.appUrl}ClosedReason/DeleteResolvedReason/${id}`)
        .toPromise()
        .then((res) => res);
  }

  deleteUnResolveReason(id){
    return this.http.delete<any>(`${environment.appUrl}ClosedReason/DeleteUnresolvedReason/${id}`)
        .toPromise()
        .then((res) => res);
  }

}